<p>test works!</p>
<app-carousel [catId]=6></app-carousel>